import { z } from 'zod';
import { zI18nKey, zItemId, zLetterId, zProductId, zSetId } from './ids';
import { zRewards } from './progression';

export const zNeighborhoodStoryId = z.enum(['lam', 'elias']);
export type NeighborhoodStoryId = z.output<typeof zNeighborhoodStoryId>;
export const zStoryGate = z.object({ storyId: zNeighborhoodStoryId, stage: z.number().int().min(1).max(4) });

/** Four permanent, player-paced steps: meet, supplies, decorate, welcome customers. */
export const zNeighborhoodStoryDef = z.object({
  id: zNeighborhoodStoryId,
  titleKey: zI18nKey,
  speakerKey: zI18nKey,
  setId: zSetId,
  inviteLetterId: zLetterId,
  requiresStory: zNeighborhoodStoryId.optional(),
  supplies: z.array(z.object({ itemId: zProductId, qty: z.number().int().positive() })).min(1),
  decorationCount: z.number().int().positive(),
  customerCount: z.number().int().positive(),
  steps: z
    .array(
      z.object({
        titleKey: zI18nKey,
        bodyKey: zI18nKey,
        endingKey: zI18nKey,
        rewards: zRewards,
      }),
    )
    .length(4),
  keepsakeItemId: zItemId,
});
export type NeighborhoodStoryDef = z.output<typeof zNeighborhoodStoryDef>;
export type NeighborhoodStoryDefInput = z.input<typeof zNeighborhoodStoryDef>;
